import PropTypes from 'prop-types';

export const SelectedLocaleModel = PropTypes.string;
